// src/router.tsx
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import * as Sentry from "@sentry/tanstackstart-react";

export function getRouter() {
  const router = createRouter({
    routeTree,
    scrollRestoration: true,
    // Enable intent-based preloading (on hover/touch)
    defaultPreload: "intent",
    defaultPreloadDelay: 50, // Start preloading after 50ms hover
    // Let React Query handle caching (it has staleTime: 5min)
    defaultPreloadStaleTime: 0,
    // Context for sharing session across routes
    context: {
      session: undefined as any,
    },
    defaultViewTransition: true,
  });
  if (!router.isServer) {
    Sentry.init({
      dsn: "https://9121859fff4e68201b41bd04923d7b2e@o4510613678718976.ingest.de.sentry.io/4510614046244944",
      environment: "prod",
      // Adds request headers and IP for users, for more info visit:
      // https://docs.sentry.io/platforms/javascript/guides/tanstackstart-react/configuration/options/#sendDefaultPii
      sendDefaultPii: true,
      integrations: [
        //  performance
        Sentry.tanstackRouterBrowserTracingIntegration(router),
        //  performance
        //  session-replay
        Sentry.replayIntegration(),
        //  session-replay
        //  user-feedback
        // Sentry.feedbackIntegration({
        //   // Additional SDK configuration goes in here, for example:
        //   colorScheme: "system",
        //   triggerLabel: "Send Feedback",
        //   submitButtonLabel: "Send Feedback",
        // }),
        //  user-feedback
      ],
      //  logs
      // Enable logs to be sent to Sentry
      enableLogs: true,
      //  logs
      //  performance
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for tracing.
      // We recommend adjusting this value in production.
      // Learn more at https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
      tracesSampleRate: 1.0,
      //  performance
      //  session-replay
      // Capture Replay for 10% of all sessions,
      // plus for 100% of sessions with an error.
      // Learn more at https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      //  session-replay
    });
  }
  return router;
}
